export default __webpack_public_path__ + "static/media/biofit-builder-foundation-upholstered.71ae4e48.png";